import React, { useState, useEffect } from 'react';
import adminApi from '../services/adminApi';

function DashboardPage() {
  const [stats, setStats] = useState(null);
  const [promoCount, setPromoCount] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = async () => {
    try {
      setIsLoading(true);
      const [statsResponse, promoResponse] = await Promise.all([
        adminApi.getDashboardStats(),
        adminApi.getPromoMeals(),
      ]);
      setStats(statsResponse);
      setPromoCount((promoResponse?.promoMeals || []).length);
    } catch (err) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) {
    return (
      <div className="admin-loading">
        <div className="admin-spinner"></div>
        <p>Loading dashboard...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="admin-card">
        <p style={{ color: '#dc2626' }}>Error: {error}</p>
        <button className="admin-btn admin-btn-primary" onClick={loadStats}>
          Retry
        </button>
      </div>
    );
  }

  return (
    <div>
      <div className="admin-page-header">
        <h1>Dashboard</h1>
        <p>Overview of your application statistics</p>
      </div>

      {/* User Stats */}
      <h3 style={{ marginBottom: '1rem', color: '#374151' }}>👥 Users</h3>
      <div className="admin-stats-grid">
        <div className="admin-stat-card">
          <div className="label">Total Users</div>
          <div className="value">{stats?.users?.total?.toLocaleString() || 0}</div>
        </div>
        <div className="admin-stat-card">
          <div className="label">New Today</div>
          <div className="value">{stats?.users?.today?.toLocaleString() || 0}</div>
          {stats?.users?.today > 0 && (
            <div className="change positive">+{stats.users.today} today</div>
          )}
        </div>
        <div className="admin-stat-card">
          <div className="label">This Week</div>
          <div className="value">{stats?.users?.thisWeek?.toLocaleString() || 0}</div>
        </div>
        <div className="admin-stat-card">
          <div className="label">This Month</div>
          <div className="value">{stats?.users?.thisMonth?.toLocaleString() || 0}</div>
        </div>
      </div>

      {/* Meal Plan Stats */}
      <h3 style={{ marginBottom: '1rem', color: '#374151' }}>🍽️ Meal Plans</h3>
      <div className="admin-stats-grid">
        <div className="admin-stat-card">
          <div className="label">Total Plans</div>
          <div className="value">{stats?.mealPlans?.total?.toLocaleString() || 0}</div>
        </div>
        <div className="admin-stat-card">
          <div className="label">Generated Today</div>
          <div className="value">{stats?.mealPlans?.today?.toLocaleString() || 0}</div>
          {stats?.mealPlans?.today > 0 && (
            <div className="change positive">+{stats.mealPlans.today} today</div>
          )}
        </div>
        <div className="admin-stat-card">
          <div className="label">This Week</div>
          <div className="value">{stats?.mealPlans?.thisWeek?.toLocaleString() || 0}</div>
        </div>
        <div className="admin-stat-card">
          <div className="label">This Month</div>
          <div className="value">{stats?.mealPlans?.thisMonth?.toLocaleString() || 0}</div>
        </div>
        <div className="admin-stat-card">
          <div className="label">Promo Meals</div>
          <div className="value">{promoCount.toLocaleString()}</div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="admin-card" style={{ marginTop: '2rem' }}>
        <div className="admin-card-header">
          <h3>Quick Actions</h3>
        </div>
        <div style={{ display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
          <a href="/admin/users" className="admin-btn admin-btn-primary">
            View All Users
          </a>
          <a href="/admin/settings" className="admin-btn admin-btn-secondary">
            Manage Settings
          </a>
          <a href="/admin/ab-tests" className="admin-btn admin-btn-secondary">
            Configure A/B Tests
          </a>
          <a href="/admin/promo" className="admin-btn admin-btn-secondary">
            Manage Promo
          </a>
        </div>
      </div>

      {/* Last Updated */}
      {stats?.generatedAt && (
        <p style={{ marginTop: '2rem', color: '#9ca3af', fontSize: '0.875rem' }}>
          Last updated: {new Date(stats.generatedAt).toLocaleString()}
        </p>
      )}
    </div>
  );
}

export default DashboardPage;
